import slugify from "slugify"
import Fingerprint2 from 'fingerprintjs2'

function getFingerprint() {
  return new Promise((resolve, reject) => {
    async function getHash() {
      const options = {
        excludes: {
          plugins: true,
          localStorage: true,
          adBlock: true,
          screenResolution: true,
          availableScreenResolution: true,
          enumerateDevices: true,
          pixelRatio: true,
          doNotTrack: true
        }
      }

      try {
        const components = await Fingerprint2.getPromise(options)
        const values = components.map(component => component.value)
        //   console.log('fingerprint hash components', components ,String(Fingerprint2.x64hash128(values.join(''), 31))

        return String(Fingerprint2.x64hash128(values.join(''), 31))
      } catch (e) {
        reject(e)
      }
    }

    if (window.requestIdleCallback) {
      // console.log('requestIdleCallback')
      requestIdleCallback(async () => resolve(await getHash()))
    } else {
      // console.log('setTimeout')
      setTimeout(async () => resolve(await getHash()), 500)
    }
  })
}

const formatNumber = (value) => {
  value += ''
  const list = value.split('.')
  const prefix = list[0].charAt(0) === '-' ? '-' : ''
  let num = prefix ? list[0].slice(1) : list[0]
  let result = ''
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`
    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`
}

const deleteArrayItem = (item, array) => {

  const index = array.indexOf(item)
  let newArray

  if (index > -1) {
    newArray = array
    newArray.splice(index, 1)
    if (!newArray) {
      newArray = []
    }
  }

  return newArray
}

const deleteArrayObject = (item, key, array) => {

  let index = array.findIndex(d => d[key] === item[key])
  let newArray

  if (index > -1) {
    newArray = array
    newArray.splice(index, 1)
    if (!newArray) {
      newArray = []
    }
  }

  return newArray
}

const arrayUniqueObject = (array = [], compare) => {
  const newArray = array.sort((a, b) => a[compare] - b[compare])
  const verify = (a, b) => (a && a[compare] === b[compare])
  let i = -1, arraySend = []

  newArray.forEach(f => {
    i++
    if (!verify(newArray[i - 1], f)) {
      arraySend.push(f)
    }
  })

  return arraySend
}

const isEmptyObject = obj => {
  return (Object.getOwnPropertyNames(obj).length === 0);
}

const getFormArrValue = (arr, name) => {
  let value = arr.find(a => { return a.name === name })
  return value.value
}

const makeSlug = text => {
  return slugify(text, { lower: true }).replace(/[^\w]+/g, '')
}

const makeUrl = text => {
  return slugify(text, { replacement: '-', remove: '.', lower: true })
}

const makeId = id => {
  return `${(id.substring(0, 1) + id.substring(8, 9)).toUpperCase()}`
}

export {
  formatNumber,
  deleteArrayItem,
  deleteArrayObject,
  isEmptyObject,
  arrayUniqueObject,
  getFormArrValue,
  makeSlug,
  makeUrl,
  getFingerprint,
  makeId
}